// OLD COLORS
// 14804A // opened
// 990407 // reopen
// 007481 // solved

import {
  alarWarningLineIcon,
  arrowDownDoubleIcon,
  arrowUpDoubleIcon,
  equalLineIcon,
} from "@src/assets/images/svgs";

// EB5757 // escalated
export const TicketConstants = {
  STATUSES: {
    all: { KEY: "all", LABEL: "All", COLOR: "", count: 0 },
    opened: { KEY: "opened", LABEL: "Opened", COLOR: "#F17B2C", count: 0 },
    reopened: {
      KEY: "reopened",
      LABEL: "Reopened",
      COLOR: "#AF1D38",
      count: 0,
    },
    solved: { KEY: "solved", LABEL: "Solved", COLOR: "#38C793", count: 0 },
    closed: { KEY: "closed", LABEL: "Closed", COLOR: "#176448", count: 0 },
    overdue: { KEY: "overdue", LABEL: "Overdue", COLOR: "#F2AE40", count: 0 },
    escalate: {
      KEY: "escalate",
      LABEL: "Escalated",
      COLOR: "#DF1C41",
      count: 0,
    },
    escalated: {
      KEY: "escalated",
      LABEL: "Escalated",
      COLOR: "#DF1C41",
      count: 0,
    },
    myEscalation: {
      KEY: "myEscalation",
      LABEL: "My Escalated",
      COLOR: "#DF1C41",
      count: 0,
    },
    bookmark: {
      KEY: "bookmark",
      LABEL: "Bookmarked",
      COLOR: "#FFD700",
      count: 0,
    },

  },
  PRIORITIES: {
    high: {
      KEY: "high",
      LABEL: "High",
      COLOR: "#AF1D38",
      ICON: arrowUpDoubleIcon,
    },
    medium: {
      KEY: "medium",
      LABEL: "Medium",
      COLOR: "#C2540A",
      ICON: equalLineIcon,
    },
    low: {
      KEY: "low",
      LABEL: "Low",
      COLOR: "#2D9F75",
      ICON: arrowDownDoubleIcon,
    },
    critical: {
      KEY: "critical",
      LABEL: "Critical",
      COLOR: "#DF1C41",
      ICON: alarWarningLineIcon,
    },
    blank: { KEY: "", LABEL: "", COLOR: "" },
  },
  BLANKS: {
    PRIORITY: { KEY: "", LABEL: "", COLOR: "" },
  },
  COMMENT_TYPE_LABELS: {
    reopened: {
      KEY: "reopened",
      LABEL: "Reopened",
      COLOR: "light-purple",
      hexCode: "#AF1D38", // matches STATUSES.reopened
    },
    closed: {
      KEY: "closed",
      LABEL: "Closed",
      COLOR: "light-danger",
      hexCode: "#176448", // matches STATUSES.closed
    },
    solved: {
      KEY: "solved",
      LABEL: "Solved",
      COLOR: "light-success",
      hexCode: "#38C793", // matches STATUSES.solved
    },
    "Returned to requester": {
      KEY: "Returned to requester",
      LABEL: "Returned to Requester",
      COLOR: "light-returnTo",
      hexCode: "#F2AE40", // suggested: warning / attention
    },
    dependency_added: {
      KEY: "dependency_added",
      LABEL: "Dependency Added",
      COLOR: "light-success",
      hexCode: "#38C793", // suggested: success / progress
    },
    "sub-task": {
      KEY: "sub-task",
      LABEL: "Sub Task",
      COLOR: "light-warning",
      hexCode: "#F17B2C", // suggested: opened / in-progress
    },

    default: {
      KEY: "default",
      LABEL: "Update",
      COLOR: "light-warning",
      hexCode: "#F17B2C", // neutral update
    },
  },
  TIMELINE_ACTIONS: {
    Comment_Deleted_at: { KEY: "Comment_Deleted_at", LABEL: "Comment Deleted" },
    escalation_flag_false: { KEY: "escalation_flag_false", LABEL: "Escalation Flag Set False" },
    escalation_flag_true: { KEY: "escalation_flag_true", LABEL: "Escalation Flag Set True" },
    "In Progress": { KEY: "In Progress", LABEL: "In Progress" },
    "Returned to requester": {
      KEY: "Returned to requester",
      LABEL: "Returned To Requester",
    },
    assign_at: { KEY: "assign_at", LABEL: "Assigned" },
    unassign_at: { KEY: "unassign_at", LABEL: "Unassigned" },
    closed: { KEY: "closed", LABEL: "Closed" },
    closed_at: { KEY: "closed_at", LABEL: "Closed" },
    comment_at: { KEY: "comment_at", LABEL: "Commented" },
    commented_at: { KEY: "commented_at", LABEL: "Commented" },
    created_At: { KEY: "created_At", LABEL: "Created" },
    dynamic_field_archived: {
      KEY: "dynamic_field_archived",
      LABEL: "Dynamic Field Archived",
    },
    escalated: { KEY: "escalated", LABEL: "Escalated" },
    escalated_at: { KEY: "escalated_at", LABEL: "Escalated" },
    opened: { KEY: "opened", LABEL: "Opened" },
    reminded: { KEY: "reminded", LABEL: "Reminded" },
    reopened: { KEY: "reopened", LABEL: "Reopened" },
    reopened_at: { KEY: "reopened_at", LABEL: "Reopened" },
    return_to_requester_at: {
      KEY: "return_to_requester_at",
      LABEL: "Returned To Requester",
    },
    solved: { KEY: "solved", LABEL: "Solved" },
    solved_at: { KEY: "solved_at", LABEL: "Solved" },
    "sub-task-comment_at": {
      KEY: "sub-task-comment_at",
      LABEL: "Sub Task Commented",
    },
    "sub-task-created": { KEY: "sub-task-created", LABEL: "Sub Task Created" },
    "sub-task-status-changed": {
      KEY: "sub-task-status-changed",
      LABEL: "Sub Task Status Changed",
    },
    updated_at: { KEY: "updated_at", LABEL: "Updated" },

    dynamic_field_added: { KEY: "dynamic_field_added", LABEL: "Dynamic Field Added", SHOW_HISTORY: true },
    subject_updated: { KEY: "subject_updated", LABEL: "Subject Updated", SHOW_HISTORY: true },
    description_updated: { KEY: "description_updated", LABEL: "Description Updated", SHOW_HISTORY: true },
    priority_updated: { KEY: "priority_updated", LABEL: "Priority Updated", SHOW_HISTORY: true },
    due_date_updated: { KEY: "due_date_updated", LABEL: "Due Date Updated", SHOW_HISTORY: true },
    tags_updated: { KEY: "tags_updated", LABEL: "Tags Updated", SHOW_HISTORY: true},
    email_to_updated: { KEY: "email_to_updated", LABEL: "Email To Updated", SHOW_HISTORY: true },
    attachments_updated: { KEY: "attachments_updated", LABEL: "Attachments Updated", SHOW_HISTORY: true },
    dynamic_field_updated: { KEY: "dynamic_field_updated", LABEL: "Dynamic Field Updated", SHOW_HISTORY: true },

    subject_removed: { KEY: "subject_removed", LABEL: "Subject Removed", SHOW_HISTORY: true },
    description_removed: { KEY: "description_removed", LABEL: "Description Removed", SHOW_HISTORY: true },
    priority_removed: { KEY: "priority_removed", LABEL: "Priority Removed", SHOW_HISTORY: true },
    due_date_removed: { KEY: "due_date_removed", LABEL: "Due Date Removed", SHOW_HISTORY: true },
    tags_removed: { KEY: "tags_removed", LABEL: "Tags Removed", SHOW_HISTORY: true },
    email_to_removed: { KEY: "email_to_removed", LABEL: "Email To Removed", SHOW_HISTORY: true },
    attachments_removed: { KEY: "attachments_removed", LABEL: "Attachments Removed", SHOW_HISTORY: true },
    dynamic_field_removed: { KEY: "dynamic_field_removed", LABEL: "Dynamic Field Removed", SHOW_HISTORY: true },
  },
};

export const ModulesName = {
  PERMISSIONS: "permissions",
  COMMENTS: "comments",
  DYNAMIC_FIELDS: "dynamic_fields",
  ESCALATION: "escalation",
  OPERATION_CENTER: "operation_center",
  TEAMS: "teams",
  USERS: "users",
  REQUEST_LIST_USER: "request_list_user",
  RESTORE_LIST_USER: "restore_list_user",
  TRANSLATIONS: "translations",
};

export const dateFormats = {
  "ddd MMM Do YYYY, hh:mm A": "ddd MMM Do YYYY, hh:mm A",
  "DD MMM YYYY": "DD MMM YYYY",
  "YYYY-MM-DD": "YYYY-MM-DD",
  "DD/MM/YYYY": "DD/MM/YYYY",
  "MM/DD/YYYY": "MM/DD/YYYY",
  "MMMM D, YYYY": "MMMM D, YYYY",
  "D MMMM YYYY": "D MMMM YYYY",
  "ddd, DD MMM YYYY": "ddd, DD MMM YYYY",
  "dddd, MMMM D, YYYY": "dddd, MMMM D, YYYY",
  "YYYY.MM.DD": "YYYY.MM.DD",
  "DD-MMM-YYYY": "DD-MMM-YYYY",
  "MMM D, YYYY hh:mm A": "MMM D, YYYY hh:mm A",
};

export const legalInfoInitialContent = () => {
  const project = process.env.REACT_APP_PROJECT;
  switch (project) {
    case "nhcc":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Ministry of Health – National Health Command Centre (“MOH-NHCC”)
           under the brand NHCC Ticketing. Access to and use of this product,
                Enovii LiveAgent, or NHCC Ticketing are governed by these Terms
                of Use.`;
    case "CC-MOHU":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Ministry of Hajj and Umrah (MOHU) under the brand Mohu Ticketing. Access to and use of this product,
                Enovii LiveAgent, or Mohu Ticketing are governed by these Terms
                of Use.`;
    case "hhc-nmr":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Health Holding Company - Navigation and Monitring Response (HHC - NMR)
           under the brand NMR Ticketing. Access to and use of this product,
                Enovii LiveAgent, or NMR Ticketing are governed by these Terms
                of Use.`;
    case "haram":
      return `Ascend Solutions Limited (“Company”) owns and operates
         this product “Enovii LiveAgent”(Product), licensed and white-labeled
          to the Haramain (Haramain) under the brand Haram Ticketing. Access to and use of this product,
                Enovii LiveAgent, or Haram Ticketing are governed by these Terms
                of Use.`;
  }
};

export const NOTIFICATION_TABS = {
  EMAIL: "email",
  SMS: "sms",
};

export const NOTIFICATION_TAB_OPTIONS = [
  {
    key: NOTIFICATION_TABS.EMAIL,
    label: "Email",
  },
  {
    key: NOTIFICATION_TABS.SMS,
    label: "SMS",
  },
];

